module.exports = __webpack_public_path__ + "64bd7ead894168bb107f40384811e7b2.MP3";